export default "__VITE_ASSET__95JdTW8x__"